import useTableFilters from "@/hooks/useTableFilters";
import ProjectCombobox from "components/directus/combobox/project";
import { StatusMultiSelect } from "components/multi-select/status";
import { FilterActions } from "components/filter/actions";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";
import TypeFilter from "components/job/type/filter";

export default function ContractFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  clearFilters,
  defaultFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      project: undefined,
      status: undefined,
      type: undefined,
      ...defaultFilters,
    },
  });

  return (
    <FiltersList>
      <FilterWrapper label="Project">
        <ProjectCombobox
          value={localFilters.project?._eq}
          className="w-full"
          placeholder="Search and Select"
          searchPlaceholder="Search Project..."
          dependsOn={isOpen}
          onChange={(selectedItem) =>
            handleSetLocalFilters({
              ...localFilters,
              project: selectedItem ? { _eq: selectedItem } : undefined,
            })
          }
          hideLabel
        />
      </FilterWrapper>

      <FilterWrapper label="Status">
        <StatusMultiSelect
          collection="contracts"
          values={localFilters?.status?._in}
          onChange={(values) => {
            handleSetLocalFilters({
              ...localFilters,
              status: values.length ? { _in: values } : undefined,
            });
          }}
        />
      </FilterWrapper>

      <FilterWrapper label="Type">
        <TypeFilter
          value={localFilters?.type?._eq}
          onChange={(item) =>
            handleSetLocalFilters({
              ...localFilters,
              type: item ? { _eq: item } : undefined,
            })
          }
        />
      </FilterWrapper>

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
